import React, { Component } from 'react';
import { PropTypes as T } from 'prop-types';

export default class BackboneView extends Component {
  static defaultProps = {
    wrapperTag: 'div',
  }

  static propTypes = {
    View: T.func.isRequired,
    viewProps: T.func.isRequired,
    wrapperTag: T.string,
  };

  componentDidMount() {
    this.buildAndRenderView();
  }

  componentDidUpdate() {
    this.buildAndRenderView();
  }

  buildAndRenderView() {
    const { View, viewProps } = this.props;
    this.backboneView = new View({
      ...viewProps(),
      el: this.el,
    });
    this.backboneView.render();
  }

  render() {
    const WrapperTag = this.props.wrapperTag;
    return (
      <WrapperTag ref={el => { this.el = el; }} />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/backbone_view/index.jsx